/** Acronyms / codes that stay English in every language (RTL, OTP, KYC…). */
const KEEP_AS_ENGLISH = new Set([
  'rtl', 'ltr', 'otp', 'kyc', 'gps', 'sms', 'api', 'url', 'uri', 'sku', 'gst',
  'pin', 'id', 'ids', 'ok', 'saas', 'app', 'ui', 'ux', 'csv', 'pdf', 'png',
  'jpg', 'svg', 'json', 'http', 'https', 'ios', 'android', 'fcm', 'gstin',
  'pan', 'upi', 'ifsc', 'inr', 'usd', 'eur', 'gbp', 'aed', 'km', 'kg',
  'eta', 'sla', 'qr', 'nfc', 'ble', 'ean', 's.no', 'sno',
]);

export function isKeepAsEnglish(value: string, key?: string): boolean {
  const v = String(value ?? '').trim();
  if (!v) return false;
  if (/^[\d\s.,%₹$€£¥+#\-_/\\|:;!?@&*()[\]{}<>'"`~]+$/.test(v)) return true;
  if (KEEP_AS_ENGLISH.has(v.toLowerCase())) return true;
  if (/^[A-Z0-9][A-Z0-9+./_-]{0,15}$/.test(v) && /[A-Z]/.test(v) && !/\s/.test(v)) {
    return true;
  }
  if (/^(txt_|ui\.)/i.test(v)) return true;
  if (key && v === key && /^[a-z0-9_.-]+$/i.test(v) && !/\s/.test(v)) return true;
  return false;
}
